import('@docsearch/react/style');
